var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "clubList" } } },
                    [_vm._v("$t('entities.club.plural')")]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "clubShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.club.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.club.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Email Manager",
                            prop: "emailManager"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                attrs: {
                                  disabled:
                                    _vm.model.statusManager == "verified"
                                },
                                model: {
                                  value: _vm.model.emailManager,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "emailManager", $$v)
                                  },
                                  expression: "model.emailManager"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Escudo" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "club-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.logo.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.logo.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus team-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.cropSuccess },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c959c754", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c959c754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-form.vue
// module id = null
// module chunks = 